import { getJson, postJson } from 'api/baseApi'

export const getUsersInformation = function () {
  return getJson({ url: `/api/server/usersandgroups/userinformation` })
}

export const getMfa = function (username) {
  return getJson({ url: `/api/server/usersandgroups/getverify` })
}

export const saveUsersInformation = function (usersInormations) {
  return postJson({ url: `/api/server/usersandgroups/userinformation`, data: usersInormations })
}

export const resetPassword = function (username) {
  return postJson({ url: `/api/server/usersandgroups/forgotpassword`, data: username })
}



// WEBPACK FOOTER //
// ./src/api/usersInformationApi.js